import { createSelector } from 'reselect';
import { getBookingPaxOutstandingBalance } from '..';
import getBookingPrices from '../getBookingPrices';
import isBookingLoaded from '../isBookingLoaded';
import isFamilyBooking from '../isFamilyBooking';

const getBookingBalanceValue = createSelector(
  (state, bookingReference) => isBookingLoaded(state, bookingReference),
  (state, bookingReference) => isFamilyBooking(state, bookingReference),
  (state, bookingReference) => getBookingPrices(state, bookingReference),
  (state, bookingReference) =>
    getBookingPaxOutstandingBalance(state, bookingReference),
  (loaded, isFamily, bookingPrices, paxPrices) => {
    if (!loaded) {
      return null;
    }
    return isFamily
      ? bookingPrices.outstanding_balance?.value
      : paxPrices?.value;
  },
);

export default getBookingBalanceValue;
